<template>
  <div class="d-xl-flex d-lg-flex">
    <b-col sm="12" xl="2">
      <client-sidebar
        v-on:clientChosen="setCurrentClient"
        v-on:openSeller="showModal"
      >
      </client-sidebar>
    </b-col>
    <b-col sm="auto" xl="10">
      <client-view
        v-if="currentClient"
        v-on:openSeller="showModal"
        v-bind:client-id="currentClient"
      ></client-view>
    </b-col>
    <solo-seller
      v-bind:client-id="currentClient"
      v-on:showAlert="showAlert"
    ></solo-seller>
    <info-alert
      :class="alertClass"
      v-bind:text="alertText"
      v-bind:active-error="activeAlert"
    />
  </div>
</template>

<script>
import InfoAlert from "@/components/Toasts/InfoAlert";
import ClientSidebar from "@/components/ClientPage/ClientSidebar";
import ClientView from "@/components/ClientPage/ClientView";
import SoloSeller from "@/components/ClientPage/modals/SoloSeller";

export default {
  name: "Clients",
  components: {
    SoloSeller,
    ClientSidebar,
    ClientView,
    InfoAlert,
  },
  data: function () {
    return {
      currentClient: null,
      alertClass: "",
      alertText: "",
      activeAlert: false,
    };
  },
  methods: {
    setCurrentClient(clientId) {
      this.currentClient = clientId;
    },
    showModal(client) {
      this.currentClient = client;
      this.$bvModal.show("modal-solo-seller");
    },
    showAlert(text, color) {
      this.activeAlert = true;
      this.alertClass = color;
      this.alertText = text;
      setTimeout(() => {
        this.activeAlert = false;
      }, 4000);
    },
  },
};
</script>

<style scoped></style>
